export default __webpack_public_path__ + "static/media/icon-stake.90ba12a7.svg";